import {TClientStatus} from './definitions';

export const getClientStatus = (
  temporaryBlocked: boolean | undefined,
  lockFlag: boolean | undefined,
): TClientStatus => {
  if (lockFlag) {
    return 'BLOCKED';
  }

  if (temporaryBlocked) {
    return 'INACTIVE';
  }

  return 'ACTIVE';
};
